import React from 'react';

export default function Card({
  children,
  className = '',
  padding = 'md',
  hover = false,
  ...props
}) {
  const paddings = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
    none: 'p-0'
  };

  const hoverStyle = hover ? 'hover:shadow-soft-lg transition-shadow duration-200' : '';

  return (
    <div
      className={`bg-white rounded-2xl shadow-soft ${paddings[padding]} ${hoverStyle} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}
